export default {
  marshal: (data,validationResponse) => {
    return {
      steps: data.steps || [],
      validationResponse
    };
  },
};
